import { Component } from "react";
import { AlertTriangle } from "lucide-react";

export class ErrorBoundary extends Component {
  state = { error: null };

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error("ErrorBoundary", error, info);
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div data-testid="error-boundary" className="flex min-h-[60vh] flex-col items-center justify-center gap-4 p-8 text-center">
        <AlertTriangle className="h-10 w-10 text-[#F2994A]" aria-hidden />
        <h2 className="t-h2">Une erreur est survenue</h2>
        <p className="t-body max-w-md">Rechargez la page pour continuer. Si le problème persiste, contactez contact@mamaisonsuivie.fr.</p>
        <button
          type="button"
          data-testid="error-boundary-reload"
          onClick={() => window.location.reload()}
          className="focus-ring min-h-12 rounded-xl border border-[#555555] bg-[#2A2A2A] px-6 font-bold text-white hover:border-[#D4AF37]"
        >
          Recharger
        </button>
      </div>
    );
  }
}
